import { render, staticRenderFns } from "./tradeFinance.vue?vue&type=template&id=7edbcae4&scoped=true"
import script from "./tradeFinance.vue?vue&type=script&lang=js"
export * from "./tradeFinance.vue?vue&type=script&lang=js"
import style0 from "./tradeFinance.vue?vue&type=style&index=0&id=7edbcae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edbcae4",
  null
  
)

export default component.exports